<template>
  <div class="home">
    <HomeHero />
    <HomeVolverArriba />
    <HomeQueEs />
    <HomeDimensiones />
    <HomeCerebroDigital />
    <HomeSoluciones />
    <HomeCasos />
    <HomePasos />
    <HomePreguntas />
    <HomeCierre />
  </div>
</template>

<script>
import HomeCasos from '@/components/home/HomeCasos.vue'
import HomeCerebroDigital from '@/components/home/HomeCerebroDigital.vue'
import HomeCierre from '@/components/home/HomeCierre.vue'
import HomeDimensiones from '@/components/home/HomeDimensiones.vue'
import HomeHero from '@/components/home/HomeHero.vue'
import HomePasos from '@/components/home/HomePasos.vue'
import HomePreguntas from '@/components/home/HomePreguntas.vue'
import HomeQueEs from '@/components/home/HomeQueEs.vue'
import HomeSoluciones from '@/components/home/HomeSoluciones.vue'
import HomeVolverArriba from '@/components/home/HomeVolverArriba.vue'

/**
 * HomeView
 * Portada. Solo compone las secciones de src/components/home/ en el orden del recorrido aprobado
 * por dirección el 2026-09-14 (docs/PLAN-ESTRATEGICO-CONVERSION.md §6.2 y §9).
 */
export default {
  name: 'HomeView',
  components: {
    HomeCasos,
    HomeCerebroDigital,
    HomeCierre,
    HomeDimensiones,
    HomeHero,
    HomePasos,
    HomePreguntas,
    HomeQueEs,
    HomeSoluciones,
    HomeVolverArriba
  }
}
</script>
